module.exports = __webpack_public_path__ + "img/coaches.930b9412.svg";